var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreakArchitectureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99807 4.09375L6.30747 0.09375H9.9981L7.68867 4.09375H3.99807ZM9.9981 4.09375L12.3075 0.09375H15.9981L13.6887 4.09375H9.9981ZM15.9981 4.09375L18.3075 0.09375H19.0082C19.556 0.09375 20 0.5387 20 1.08715V17.1003C20 17.6489 19.5447 18.0938 19.0082 18.0938H0.9918C0.44405 18.0938 0 17.6488 0 17.1003V1.08715C0 0.53851 0.45531 0.09375 0.9918 0.09375H3.99807L2 3.55451V16.0938H18V4.09375H15.9981Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakArchitectureIcon);
export default __webpack_public_path__ + "static/media/BreakArchitectureIcon.5fec5b7fe05ccba963489d79e2ee95ba.svg";
export { ForwardRef as ReactComponent };